import React from "react";

const Experiences = () => {
  const experiences = [
    {
    id: 1,
    count: "01.",
    company: "Freelance",
    role: "Web Developer & SEO Practitioner",
    date: "Jan 2025 – Present",
    location: "Remote",
    highlights: [
      "Designed, developed, and maintained websites for businesses and personal brands.",
      "Built responsive and performance-focused websites using modern web technologies.",
      "Implemented on-page SEO, technical SEO improvements, and website optimization strategies.",
      "Managed hosting, migrations, security updates, and website maintenance.",
      "Worked directly with clients from requirement gathering to deployment and support.",
    ],
  },
  {
    id: 2,
    count: "02.",
    company: "Tuneleaf Ventures Pvt. Ltd.",
    role: "Digital Transformation Executive",
    date: "Jun 2025 – Apr 2026",
    location: "Goa & Leh, India",
    highlights: [
      "Led digital transformation initiatives across hospitality and tourism businesses.",
      "Managed websites, CRM systems, automation workflows, and digital operations.",
      "Improved operational efficiency through technology-driven solutions.",
      "Coordinated with management teams to streamline digital processes.",
      "Supported online growth, digital presence, and business automation projects.",
    ],
  },

  

  {
    id: 3,
    count: "03.",
    company: "Creative Web Planet",
    role: "Website Developer",
    date: "Jul 2024 – May 2025",
    location: "Remote",
    highlights: [
      "Developed and maintained websites for clients across multiple industries.",
      "Built responsive user interfaces and customized CMS-based solutions.",
      "Optimized website performance, accessibility, and mobile responsiveness.",
      "Implemented SEO best practices and conversion-focused improvements.",
      "Collaborated with clients and teams to deliver high-quality digital solutions.",
    ],
  },

  {
    id: 4,
    count: "04.",
    company: "JoinYourTrip",
    role: "Founder",
    date: "Jun 2024 – Dec 2025",
    location: "Hybrid",
    highlights: [
      "Founded and developed a travel-focused platform and community initiative.",
      "Led product planning, website development, and user experience improvements.",
      "Managed branding, digital presence, and growth initiatives.",
      "Conducted market research and validated product concepts.",
      "Coordinated development workflows and strategic planning activities.",
    ],
  },

  {
    id: 5,
    count: "05.",
    company: "Rovinhood Coliving",
    role: "Website Maintenance & Developer",
    date: "Jan 2024 – Jun 2024",
    location: "Remote",
    highlights: [
      "Maintained and enhanced the company website and digital assets.",
      "Implemented website updates, bug fixes, and performance improvements.",
      "Managed CRM integrations, forms, and workflow automations.",
      "Improved user experience, responsiveness, and website reliability.",
      "Assisted with analytics tracking and search engine optimization initiatives.",
    ],
  },

  {
    id: 6,
    count: "06.",
    company: "CashmereCharmers",
    role: "Founder",
    date: "Sep 2023 – May 2024",
    location: "Remote",
    highlights: [
      "Built and managed an online travel and tourism-focused venture.",
      "Developed the website, branding assets, and digital infrastructure.",
      "Created content and growth strategies to increase online visibility.",
      "Managed customer engagement and digital marketing initiatives.",
      "Explored SEO, content marketing, and audience acquisition strategies.",
    ],
  },

  {
    id: 7,
    count: "07.",
    company: "Webtoils Development LLP",
    role: "Web Developer Intern",
    date: "Jun 2023 – Dec 2023",
    location: "Delhi, India",
    highlights: [
      "Developed responsive websites for international clients.",
      "Worked with modern web technologies and CMS platforms.",
      "Customized websites according to business and client requirements.",
      "Collaborated with development teams on multiple web projects.",
      "Delivered optimized, mobile-friendly, and user-focused digital experiences.",
    ],
  },
];
  return (
    <section className="experiences position-relative py-5 primary-bg">
      <div className="container">
        <div className="row justify-content-between">
          {/* Left Intro */}
          <div className="col-12 col-lg-3 mb-5 mb-lg-0">
            <div className="sticky-top" style={{ top: "120px" }}>
              <span className="text-uppercase small text-muted">
                Career Journey
              </span>

              <h2 className="display-6 fw-bold mt-2">
  Experience &
  <br />
  Projects
</h2>

<p className="mt-3 text-secondary">
  Web development, digital transformation, product building, SEO, and
  entrepreneurial experience across startups, client projects, and
  technology-driven businesses.
</p>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-12 col-lg-8">
            <div className="row g-4">
              {experiences.map((exp) => (
                <div key={exp.id} className="col-12">
                  <div className="experience-card p-4 p-lg-5 rounded-4 border">
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                      <div>
                        <span className="text-muted fw-semibold">
                          {exp.count}
                        </span>

                        <h3 className="mt-2 mb-1 fw-bold">
                          {exp.company}
                        </h3>

                        <h5 className="text-secondary fw-medium">
                          {exp.role}
                        </h5>
                      </div>

                      <div className="text-lg-end">
                        <span className="badge  bg px-3 py-2 rounded-pill">
                          {exp.date}
                        </span>

                        <p className="small text-muted mt-2 mb-0">
                          {exp.location}
                        </p>
                      </div>
                    </div>

                    <div className="mt-4">
                      <ul className="list-unstyled m-0">
                        {exp.highlights.map((item, index) => (
                          <li
                            key={index}
                            className="d-flex align-items-start mb-3"
                          >
                            <span
                              className="me-3 mt-2 rounded-circle bg-dark"
                              style={{
                                width: "8px",
                                height: "8px",
                                minWidth: "8px",
                              }}
                            ></span>

                            <span className="text-secondary">
                              {item}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experiences;